import { render, staticRenderFns } from "./menu-checkbox.svg.vue?vue&type=template&id=92ef2c74&"
import script from "./menu-checkbox.svg.vue?vue&type=script&lang=js&"
export * from "./menu-checkbox.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports